export default __webpack_public_path__ + "static/media/playing.423387ea.gif";